import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const SettingsContext = createContext({ settings: {}, loading: true });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/settings/public")
      .then((r) => setSettings(r.data || {}))
      .catch(() => setSettings({}))
      .finally(() => setLoading(false));
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
